<template>
  <tooltip-hover
    :text="$t('partnered_creator')"
    class="tw-flex tw-justify-center tw-items-center"
    fixed
    :position="position"
  >
    <base-icon
      icon="partner_program"
      :class="[discussion ? 'tw-w-4 lg:tw-w-5' : 'tw-w-6']"
    />
  </tooltip-hover>
</template>

<script>
import TooltipHover from '@components/Message/TooltipHover.vue'
export default {
  components: {
    TooltipHover,
  },
  props: {
    discussion: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'top',
      validator: (value) =>
        [
          'top',
          'bottom',
          'left',
          'right',
          'top left',
          'bottom left',
          '',
        ].includes(value),
    },
  },
}
</script>
